import { CloseButton, TextInput } from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/** A filter box under a heading (a ``DataTable``'s, the trial grid's): applied a moment after the typing stops; ✕ clears
 *  it. What it takes: ``compileFilter``. */
export function FilterBox(props: { value: string; onChange: (text: string) => void; numeric: boolean; name: string }) {
  const { t } = useTranslation();
  const [text, setText] = useState(props.value);
  const push = useDebouncedCallback(props.onChange, 250);
  // cleared from outside (Clear filters): the box follows, unless typing is still to be applied
  useEffect(() => {
    if (!push.isPending()) setText(props.value);
  }, [props.value, push]);
  return (
    <TextInput
      size="xs"
      className="dt-filter"
      value={text}
      onChange={(e) => {
        setText(e.currentTarget.value);
        push(e.currentTarget.value);
      }}
      placeholder={t(props.numeric ? "dataTable.numberPlaceholder" : "dataTable.filterPlaceholder")}
      aria-label={t("dataTable.filterLabel", { column: props.name })}
      title={t(props.numeric ? "dataTable.numberHelp" : "dataTable.textHelp")}
      rightSection={
        text ? (
          <CloseButton
            size="xs"
            aria-label={t("dataTable.clearFilter")}
            onClick={() => {
              push.cancel();
              setText("");
              props.onChange("");
            }}
          />
        ) : null
      }
    />
  );
}
